class $14cbc558cceff0eb$var$HomeView {
    faders = document.querySelectorAll(".fade-in");
    sliders = document.querySelectorAll(".slide-in");
    btnContactUs = document.querySelector(".btn-contact-us");
    btnCloseContact = document.querySelector(".btn-close-contact");
    contactUsForm = document.querySelector(".form-contact");
    // btnCloseNav = document.querySelector(".btn-close-nav");
    btnMenu = document.querySelector(".menu-mobile");
    nav = document.querySelector(".list-nav");
    appearOnScroll() {
        let options = {
            threshold: 0.5
        };
        if (!window.innerWidth < 413) options = {
            threshold: 0.1
        };
        const observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                entry.target.classList.add("appear");
                observer.unobserve(entry.target);
            });
        }, options);
        this?.faders.forEach((fader)=>{
            observer.observe(fader);
        });
        this?.sliders.forEach((slider)=>{
            observer.observe(slider);
        });
    }
    contactUsBtn() {
        this.btnContactUs?.addEventListener("click", ()=>{
            this.contactUsForm.classList.add("appear");
        });
        this.btnCloseContact?.addEventListener("click", ()=>{
            this.contactUsForm.classList.remove("appear");
        });
    }
    mobileMenu() {
        this.btnMenu?.addEventListener("click", ()=>{
            this.nav.classList.toggle("hidden-mobile");
        });
    // this.btnCloseNav.addEventListener("click", () => {
    //   this.nav.classList.add("hidden-mobile");
    // });
    }
}
var $14cbc558cceff0eb$export$2e2bcd8739ae039 = new $14cbc558cceff0eb$var$HomeView();


class $92c95d3989690c89$var$CoursesView {
    courseCards = document.querySelectorAll(".course");
    curScaledCard = [
        document.querySelector(".scale")
    ];
    allDots = document.querySelectorAll(".dot");
    faqs = document.querySelectorAll(".faq");
    dots = document.querySelectorAll(".dots");
    courseGroup = document.querySelector(".course-i");
    coursePrivate = document.querySelector(".course-ii");
    scaleCards() {
        if (window.innerWidth < 764) {
            if (!this.curScaledCard[0]) return;
            this.curScaledCard[0].classList.remove("scale");
            // rearrange card order
            this.courseGroup.dataset.slide = "slide-ii";
            this.coursePrivate.dataset.slide = "slide-i";
            this.courseGroup.before(this.coursePrivate);
            return;
        }
        this.courseCards.forEach((card)=>{
            card.addEventListener("mouseover", (e)=>{
                // remove scale from other card
                this.curScaledCard[0].classList.remove("scale");
                // add scale to current card
                e.target.closest(".course").classList.add("scale");
                // mark new scaled card
                this.curScaledCard[0] = document.querySelector(".scale");
            });
        });
    }
    faq() {
        this.faqs.forEach((faq)=>{
            faq.addEventListener("click", ()=>{
                faq.classList.toggle("active");
            });
        });
    }
    courseCardObserver() {
        if (!window.innerWidth > 412) return;
        const options = {
            threshold: 0.5
        };
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                const dotId = entry.target.dataset.slide;
                // remove previous dot color
                document.querySelector(".cur-dot").classList.remove("cur-dot");
                // change cur dot
                document.querySelector(`#${dotId}`).classList.add("cur-dot");
            });
        }, options);
        this.courseCards.forEach((card)=>{
            observer.observe(card);
        });
    }
    dotDetector() {
        this.allDots.forEach((dot)=>{
            dot.addEventListener("click", (dot)=>{
                const slideId = dot.target.id;
                const nextSlide = document.querySelector(`[data-slide='${slideId}']`);
                nextSlide.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest"
                });
            });
        });
    }
}
var $92c95d3989690c89$export$2e2bcd8739ae039 = new $92c95d3989690c89$var$CoursesView();


class $6828cf665c5e643c$var$WebinarView {
    quoteArr = [
        [
            `I miss signing into your classes right about now.`,
            `Michael Hassid`
        ],
        [
            `I just wanted to tell you that I really enjoyed the session about Bach and learned a lot about someone and something that I had zero knowledge about. Yesterday I listened a bit to 'the best pieces of Bach' - really impressive music. Thanks.`,
            `Akiva Kraines`
        ],
        [
            `I must say I never really connected to Beethoven's 8th sonata but hearing Rubinstein play it, as well as having shared it with you and everyone the other night, it has switched something in me and now I am so deeply moved by it.`,
            `Gershi`
        ],
        [
            `It was beautiful as always. It is such a mechayae to break out of my day for a few minutes to listen to music - and to have a guided tour of how to listen.`,
            `Akiva Kraines`
        ]
    ];
    counter = [
        0
    ];
    overallCounter = [
        0
    ];
    quoteTextEl = document.querySelector(".section-webinars .container-quote-text .title-third");
    // entryPage = document.querySelector(".section-webinars .grid-i");
    // displayEntryPage() {
    //   if (!this.entryPage) return;
    //   setTimeout(() => {
    //     this.entryPage.classList.add("fade-out");
    //   }, 2000);
    //   setTimeout(() => {
    //     this.entryPage.style.display = "none";
    //   }, 3000);
    // }
    displayQuotes() {
        setTimeout(()=>{
            let intervalId = setInterval(()=>{
                if (!intervalId) return;
                this.quoteTextEl.innerHTML = "";
                let html = `
        <q class="quote-text"
              >${this.quoteArr[this.counter[0]][0]}
            </q>
             <p class="quoted-by">${this.quoteArr[this.counter[0]][1]}</p>
        `;
                this.quoteTextEl.insertAdjacentHTML("afterbegin", html);
                setTimeout(()=>{
                    this.quoteTextEl.querySelector(".quote-text").style.opacity = "1";
                    this.quoteTextEl.querySelector(".quoted-by").style.opacity = "1";
                }, 20);
                this.counter[0] = this.counter[0] + 1;
                this.overallCounter[0] = this.overallCounter[0] + 1;
                if (this.counter[0] > 3) this.counter[0] = 0;
                if (this.overallCounter[0] > 20) clearInterval(intervalId);
            }, "5000");
        }, 5000);
    }
}
var $6828cf665c5e643c$export$2e2bcd8739ae039 = new $6828cf665c5e643c$var$WebinarView();


(0, $14cbc558cceff0eb$export$2e2bcd8739ae039).appearOnScroll();
(0, $14cbc558cceff0eb$export$2e2bcd8739ae039).contactUsBtn();
(0, $14cbc558cceff0eb$export$2e2bcd8739ae039).mobileMenu();
(0, $92c95d3989690c89$export$2e2bcd8739ae039).scaleCards();
(0, $92c95d3989690c89$export$2e2bcd8739ae039).faq();
(0, $92c95d3989690c89$export$2e2bcd8739ae039).courseCardObserver();
(0, $92c95d3989690c89$export$2e2bcd8739ae039).dotDetector();
// WebinarView.displayEntryPage();
(0, $6828cf665c5e643c$export$2e2bcd8739ae039).displayQuotes();


//# sourceMappingURL=home.5ad2cf76.js.map
